import AdminHeading from '@components/admin/heading/AdminHeading.tsx';

const AdminPage = () => {
  return (
    <div>
      <AdminHeading />
      <div className="p-5">
        <h2>We will render dashboard widgets</h2>
      </div>
    </div>
  );
};

export default AdminPage;
